import { useState } from 'react';
import { API_BASE_URL } from '../utils/apiConfig';

export default function PendingOrderEditModal({ order, token, onCancel, onSaved }) {
  const [items, setItems] = useState(order.orderItems.map(item => ({ ...item })));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const save = async event => {
    event.preventDefault();
    if (busy) return;
    setBusy(true); setError('');
    try {
      const response = await fetch(`${API_BASE_URL}/orders/pos/${order._id}`, {
        method: 'PUT', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ orderItems: items, remarks: 'Edited from pending payments' }),
      });
      const value = await response.json();
      if (!response.ok) throw new Error(value.message || 'Unable to edit order.');
      await onSaved(value);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 p-4">
    <form onSubmit={save} role="dialog" aria-modal="true" aria-label="Edit pending order" className="max-h-[90vh] w-full max-w-lg space-y-4 overflow-auto rounded-xl bg-white p-6">
      <h3 className="text-xl font-bold">Edit order {order.MK_order_id}</h3>
      <p className="text-sm text-gray-500">Update quantities or remove items. Prices and stock will be checked when saved.</p>
      {error && <p role="alert" className="text-red-700">{error}</p>}
      <fieldset disabled={busy} className="space-y-3">{items.map((item, index) => <div key={item._id || index} className="flex items-center gap-3">
        <label className="flex-1 text-sm">{item.name} · {item.quantity} {item.units}<input aria-label={`Quantity for ${item.name}`} required type="number" min="1" step="1" value={item.qty} onChange={e => setItems(previous => previous.map((row, i) => i === index ? { ...row, qty: e.target.value } : row))} className="ml-2 w-20 rounded border p-2" /></label>
        <button type="button" disabled={items.length === 1} onClick={() => setItems(previous => previous.filter((_, i) => i !== index))} className="text-red-700">Remove item</button>
      </div>)}</fieldset>
      <div className="flex justify-end gap-2"><button type="button" disabled={busy} onClick={onCancel} className="rounded border px-4 py-2">Cancel</button><button disabled={busy || !items.length} className="rounded bg-amber-600 px-4 py-2 text-white">{busy ? 'Saving…' : 'Save changes'}</button></div>
    </form>
  </div>;
}
